import { Navigate, Outlet } from 'react-router-dom';

import { LoadingPage } from '../components/LoadingPage';
import { useTokens } from '../hooks/useTokens';

export const AuthenticatedLayout = () => {
  const { tokens } = useTokens();

  if (tokens === undefined) {
    return <LoadingPage />;
  }

  if (tokens === null) {
    return <Navigate to="/login" replace={true} />;
  }

  return <Outlet />;
};
